module.exports = __webpack_public_path__ + "img/plus.0c3a8604.png";